var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('el-container',[_c('base-header',{attrs:{"activeIndex":_vm.activeIndex}}),_vm._v(" "),_c('router-view',{staticClass:"me-container"}),_vm._v(" "),_c('base-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.footerShow),expression:"footerShow"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-61678899","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = null
// module chunks = 